import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { Item } from 'src/graphql/report-service/generated/operations';
import TableHead from '@mui/material/TableHead';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

const ItemsForOrder = function ({ items, loading }: { items?: Item[]; loading: boolean }) {
  const { t } = useTranslation();
  const dataRows = items.map((item, index) => ({
    ...item,
    id: index,
  }));

  return (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Namn</TableCell>
            <TableCell align="right">antal</TableCell>
            <TableCell align="right">summa addons (SEK)</TableCell>
            <TableCell align="right">summa (SEK)</TableCell>
            <TableCell align="right">totalsumma (SEK)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataRows.map((row) => (
            <TableRow hover key={row.id}>
              <TableCell>{row.name}</TableCell>
              <TableCell align="right">{row.count}</TableCell>
              <TableCell align="right">
                {t('formatters.number', { val: row.addonAmount })}
              </TableCell>
              <TableCell align="right">{t('formatters.number', { val: row.amount })}</TableCell>
              <TableCell align="right">
                {t('formatters.number', { val: row.totalAmount })}
              </TableCell>
            </TableRow>
          ))}
          {loading && !dataRows.length && (
            <TableRow>
              <TableCell>
                <Skeleton variant="text" width={100} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

ItemsForOrder.defaultProps = {
  items: [],
};

export default ItemsForOrder;
